import TomSelect from "tom-select";

/**
 *
 * @param domElement
 * @param {import('tom-select/dist/types/types/index').TomSettings|Object} settings - Tom Select settings object
 * @return {TomSelect}
 */
function initTomSelectInput(domElement, settings = {}) {
	// Find DOM element if a string was passed
	if (domElement instanceof String || typeof (domElement) == 'string') {
		domElement = document.querySelector(domElement);
		if (!domElement) {
			throw 'DOM Element not found';
		}
	}


	const defaultSettings = {
		plugins: ['dropdown_input'],
		maxOptions: null, // No limit to options displayed, default is 50
	}
	const finalSettings = {
		...defaultSettings, ...settings
	}

	return new TomSelect(domElement, finalSettings);
}

export {initTomSelectInput}
